import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, LogOut } from "lucide-react";
import { api } from "../../lib/api";
import { t } from "../../lib/portalI18n";
import { usePortal } from "./PortalShell";
import { Card } from "./PortalOverview";
import { PushSettings } from "../../pwa/PushSettings";

export default function PortalMe() {
  const { me, lang, setLang, logout } = usePortal();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const exportData = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/portal/my-data");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `playmaker-mijn-gegevens-${new Date().toISOString().slice(0, 10)}.json`; a.click(); URL.revokeObjectURL(a.href);
    } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="portal-me">
      <h1 className="text-2xl font-semibold tracking-tight">{t(lang, "me")}</h1>
      <Card className="p-5 space-y-1" testid="portal-account">
        <div className="text-[11px] uppercase tracking-wider text-slate-400">{t(lang, "account")}</div>
        <div className="font-semibold">{me.name}</div>
        <div className="text-sm text-slate-500">{me.email} · {t(lang, `relation.${me.relation}`)}</div>
      </Card>
      <Card className="p-5" testid="portal-language">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{t(lang, "language")}</div>
        <div className="grid grid-cols-2 gap-2">
          {["nl", "en"].map((l) => <button key={l} onClick={() => setLang(l)} className={`h-11 rounded-xl text-sm font-semibold border transition-colors ${lang === l ? "bg-[#0f1c17] text-white border-[#0f1c17]" : "bg-white text-slate-700 border-slate-200"}`} data-testid={`portal-lang-${l}`}>{l === "nl" ? "Nederlands" : "English"}</button>)}
        </div>
      </Card>
      <Card className="p-5" testid="portal-notifications">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-3">{lang === "nl" ? "Meldingen" : "Notifications"}</div>
        <PushSettings lang={lang} />
      </Card>
      <Card className="p-5" testid="portal-export">
        <button onClick={exportData} disabled={busy} className="w-full h-11 rounded-xl bg-emerald-600 text-white text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="portal-export-btn"><Download size={16} /> {t(lang, "export")}</button>
        <div className="text-[11px] text-slate-500 mt-2">{t(lang, "export_hint")}</div>
      </Card>
      <div className="text-[11px] text-slate-500 px-1" data-testid="portal-privacy-note">{t(lang, "privacy")} <a href="/privacy" className="underline">Privacy</a> · <a href="/terms" className="underline">Terms</a></div>
      <button onClick={async () => { if (!window.confirm(lang === "nl" ? "Account definitief verwijderen? Je verliest direct toegang." : "Delete your account permanently? You lose access immediately.")) return; await api.delete("/auth/me"); await logout(); navigate("/login", { replace: true }); }} className="w-full h-11 rounded-xl border border-rose-200 bg-rose-50 text-sm font-semibold text-rose-700" data-testid="portal-delete-account">{lang === "nl" ? "Account verwijderen" : "Delete account"}</button>
      <button onClick={async () => { await logout(); navigate("/login", { replace: true }); }} className="w-full h-11 rounded-xl border border-slate-200 bg-white text-sm font-semibold text-slate-700 flex items-center justify-center gap-2" data-testid="portal-logout"><LogOut size={16} /> {t(lang, "logout")}</button>
    </div>
  );
}
